import { render, staticRenderFns } from "./StatisticsWdTurnoverCodes.vue?vue&type=template&id=36a79f92&scoped=true&"
import script from "./StatisticsWdTurnoverCodes.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnoverCodes.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsWdTurnoverCodes.vue?vue&type=style&index=0&id=36a79f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a79f92",
  null
  
)

export default component.exports